import React, { useState } from "react";
import "./BankTransfer4to5new.css";
import {
    handleTransferApi,
    handleTransferApi5to6,
    handleTransferApi5to7,
    handleTransferApi5to8,
    handleTransferApi6to9,
    handleTransferApi6to10,
    handleTransferApi7to11,
    handleTransferApi7to12,
    handleTransferApi8to13,
    handleTransferApi8to14,
    fetchFailureCountApi,
    fetchAnotherFailureCountApi,
    fetchAnotheroneFailureCountApi,
    fetchAnother13FailureCountApi,
    fetchAnother14FailureCountApi,
    fetchAnother10FailureCountApi,
    fetchAnother12FailureCountApi,
    markFraud,
} from "./services/api"; // Import the API function
import "@fortawesome/fontawesome-free/css/all.min.css";
import { useEffect } from "react";
import { FaCheckCircle, FaExclamationCircle } from "react-icons/fa"; // Import the required icons
import { fetchCount, fetchTimeTaken } from "./services/api";
// import arrowImage from "./a/arrow download.png";
import atmImage from "./atm.jpg";
import posImage from "./pos.png";
import XMark from "./xmark.png";
import QRImage from "./qrcode.jpg";
import Panic from "./panic.png";
import shoppingImage from "./onlineshopping.jpg";
import map from "./asserts/mapbutton.png";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import CloseIcon from "@mui/icons-material/Close";
import IndiaMap from "./India"; // Adjust the path to where Ind
import { handleTruncateApi, handleInsertApi } from "./services/api";
import { fetchCountApi, fetchTimeDifferenceApi } from "./services/api";
import International from "./international.png";
import crypto1 from "./crypto1.png";
import { useNavigate } from "react-router-dom";
import FederalImage from "./asserts/axis.png"; // Adjust the path if needed
import cub from "./asserts/cub.png";
import sbi from "./asserts/sbi.png";
import citi from "./asserts/citi.png";
import rbl from "./asserts/rbl3.jpg";
import indian2 from "./asserts/indian2.jpeg";
import southindian from "./asserts/southindian2.png";
import canara from "./asserts/canara.png";
import baroda from "./asserts/kvb.png";
import overseas from "./asserts/axis.png";
import idbi from "./asserts/idbi.jpg";
import hdfc from "./asserts/hdfc.png";

const BankTransfer4to5new1 = () => {
    const [amount, setAmount] = useState("1,00,000"); // Prefill amount with 1000

    const [tag5, setTag5] = useState(""); // State to hold tag5 from response
    const [tag4, setTag4] = useState("");
    const [amountTransferred5, setAmountTransferred5] = useState(""); // State for amountTransferred5
    const [amountTransferred6, setAmountTransferred6] = useState(""); // State for amountTransferred5
    const [amountTransferred7, setAmountTransferred7] = useState(""); // State for amountTransferred5
    const [amountTransferred8, setAmountTransferred8] = useState(""); // State for amountTransferred5
    const [amountTransferred9, setAmountTransferred9] = useState(""); // State for amountTransferred5
    const [amountTransferred10, setAmountTransferred10] = useState(""); // State for amountTransferred5
    const [amountTransferred11, setAmountTransferred11] = useState(""); // State for amountTransferred5
    const [amountTransferred12, setAmountTransferred12] = useState(""); // State for amountTransferred5
    const [amountTransferred13, setAmountTransferred13] = useState(""); // State for amountTransferred5
    const [amountTransferred14, setAmountTransferred14] = useState(""); // State for amountTransferred5
    const [isTransactionSuccessful, setIsTransactionSuccessful] = useState(false);
    const [amount1, setAmount1] = useState("50,000"); // Prefill amount with 1000
    const [amount2, setAmount2] = useState("25,000"); // Prefill amount with 1000
    const [amount3, setAmount3] = useState("25,000"); // Prefill amount with 1000
    const [amount4, setAmount4] = useState("20,000"); // Prefill amount with 1000
    const [amount5, setAmount5] = useState("30,000"); // Prefill amount with 1000
    const [amount6, setAmount6] = useState("15,000"); // Prefill amount with 1000
    const [amount7, setAmount7] = useState("10,000"); // Prefill amount with 1000
    const [amount8, setAmount8] = useState("20,000"); // Prefill amount with 1000
    const [amount9, setAmount9] = useState("5,000"); // Prefill amount with 1000
    const [amount10, setAmount10] = useState("1,000"); // Prefill amount with 1000
    const [amount11, setAmount11] = useState("1,000"); // Prefill amount with 1000
    const [amount12, setAmount12] = useState("1,000"); // Prefill amount with 1000
    const [amount13, setAmount13] = useState("1,000"); // Prefill amount with 1000
    const [amount14, setAmount14] = useState("1,000"); // Prefill amount with 1000
    const [amount15, setAmount15] = useState("1,000"); // Prefill amount with 1000
    const [tag6, setTag6] = useState(""); // State to show API response
    const [tag7, setTag7] = useState(""); // State to show API response
    const [isTransactionSuccessful5, setIsTransactionSuccessful5] =
        useState(false); // State for Bank 5 Transaction Success
    const [isTransactionSuccessful5to7, setIsTransactionSuccessful5to7] =
        useState(false);
    const [isTransactionSuccessful5to8, setIsTransactionSuccessful5to8] =
        useState(false);
    const [isTransactionSuccessful6to9, setIsTransactionSuccessful6to9] =
        useState(false);
    const [isTransactionSuccessful6to10, setIsTransactionSuccessful6to10] =
        useState(false);
    const [isTransactionSuccessful7to11, setIsTransactionSuccessful7to11] =
        useState(false);
    const [isTransactionSuccessful7to12, setIsTransactionSuccessful7to12] =
        useState(false);
    const [isTransactionSuccessful8to13, setIsTransactionSuccessful8to13] =
        useState(false);
    const [isTransactionSuccessful8to14, setIsTransactionSuccessful8to14] =
        useState(false);
    const [tag8, setTag8] = useState(""); // State to show API response
    const [tag9, setTag9] = useState(""); // State to show API response
    const [tag10, setTag10] = useState(""); // State to show API response
    const [tag11, setTag11] = useState(""); // State to show API response
    const [tag12, setTag12] = useState(""); // State to show API response
    const [tag13, setTag13] = useState(""); // State to show API response
    const [tag14, setTag14] = useState(""); // State to show API response
    const [panicMessage, setPanicMessage] = useState("");
    const [count, setCount] = useState(null);
    const [timeDifference, setTimeDifference] = useState(null);
    const [status, setStatus] = useState(null);
    const [status1, setStatus1] = useState(null);
    const [failureCount, setFailureCount] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [amountwithdrawal, setAmountWithdrawal] = useState("");
    const [amountwithdrawal7, setAmountWithdrawal7] = useState("");
    const [amountwithdrawal8, setAmountWithdrawal8] = useState("");
    const [status13, setStatus13] = useState(null);
    const [status14, setStatus14] = useState(null);
    const [status11, setStatus11] = useState(null);
    const [status9, setStatus9] = useState(null);
    const [status10, setStatus10] = useState(null);
    const [status12, setStatus12] = useState(null);
    const [status5, setStatus5] = useState(null);
    const [statusATM, setStatusATM] = useState("");
    const [statusPOS, setStatusPOS] = useState("");
    const [statusBuy, setStatusBuy] = useState("");
    const [statusUpi, setStatusUpi] = useState("");

    const [tagvalidity, setTagValidity] = useState(null);
    const [previousTagValidity, setPreviousTagValidity] = useState(null);
    const [loading, setLoading] = useState(false); // Loader state for Truncate API
    const [loading1, setLoading1] = useState(false); // Loader state for Insert API
    const [open, setOpen] = useState(false);
    const [showAmountStatus, setAmountStatus] = useState({
        tag5,
        tag6,
        tag7,
        tag8,
        tag9,
        tag10,
        tag11,
        tag12,
        tag13,
        tag14,
    });

    useEffect(() => {
        document.title = "TAGER AI-Bank4to5"; // Set the page title for this route
    }, []);

    // useEffect(() => {
    //   if (
    //     tag5 ||
    //     tag6 ||
    //     tag7 ||
    //     tag8 ||
    //     tag9 ||
    //     tag10 ||
    //     tag11 ||
    //     tag12 ||
    //     tag13 ||
    //     tag14
    //   ) {

    //   }

    //   setAmountStatus();
    // }, [tag5, tag6, tag7, tag8, tag9, tag10, tag11, tag12, tag13, tag14]);

    // Fetch the data when the component is mounted and periodically after every interval
    useEffect(() => {
        const fetchCount = async () => {
            try {
                const data = await fetchCountApi();
                setCount(data.count); // Update the count with the response data
                fetchCount(); // Fetch again after response
            } catch (error) {
                console.error("Error fetching data:", error);
                setTimeout(fetchCount, 1000); // Retry after 1 second
            }
        };

        fetchCount(); // Start the initial fetch
    }, []);

    useEffect(() => {
        const fetchTimeTaken = async () => {
            try {
                const data = await fetchTimeDifferenceApi();
                setTimeDifference(data.timeDifferenceInMinutes); // Update the time difference
                fetchTimeTaken(); // Fetch again after response
            } catch (error) {
                console.error("Error fetching time difference:", error);
                setTimeout(fetchTimeTaken, 1000); // Retry after 1 second
            }
        };

        fetchTimeTaken(); // Start the initial fetch
    }, []);
    // Handlers for opening and closing the modal
    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };
    const handleCloses = (event, reason) => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
            return;
        }
    };

    const fetchFailureCount = async (type) => {
        setIsLoading(true);
        try {
            const data = await fetchFailureCountApi(type);

            // Update the failure count
            // setFailureCount(data.failureCount || 0);
            // Update the tag validity
            //setPreviousTagValidity(tagvalidity);
            console.log(tagvalidity);
            if (tagvalidity != data.tagvalidity) {
                setPreviousTagValidity(tagvalidity);
                setTagValidity(data.tagvalidity); // Set tag validity
            }
            //setTagValidity(data.tagvalidity || "0");
            setFailureCount((prevCount) => data.failureCount || prevCount);

            // Update the status based on the button type
            if (type === "ATM") {
                setStatusATM(data.status);
            } else if (type === "POS") {
                setStatusPOS(data.status);
            } else if (type === "BUY") {
                setStatusBuy(data.status);
            } else if (type === "UPI MERCHANT") {
                setStatusUpi(data.status);
            }
        } catch (error) {
            console.error("Error fetching failure count:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const fetchAnotherFailureCount = async () => {
        setIsLoading(true);
        try {
            const data = await fetchAnotherFailureCountApi();
            // setPreviousTagValidity(tagvalidity);
            // setTagValidity(data.tagvalidity || "0");
            if (tagvalidity != data.tagvalidity) {
                setPreviousTagValidity(tagvalidity);
                setTagValidity(data.tagvalidity); // Set tag validity
            }
            setFailureCount((prevCount) => data.failureCount || prevCount);
            setStatus9(data.status); // Update the status for the second request
        } catch (error) {
            console.error("Error fetching another failure count:", error);
        } finally {
            setIsLoading(false);
        }
    };
    const fetchAnotheroneFailureCount = async () => {
        setIsLoading(true);
        try {
            const data = await fetchAnotheroneFailureCountApi(); // Call the separated API function
            // setPreviousTagValidity(tagvalidity);
            // setTagValidity(data.tagvalidity || "0");
            if (tagvalidity != data.tagvalidity) {
                setPreviousTagValidity(tagvalidity);
                setTagValidity(data.tagvalidity); // Set tag validity
            }
            setFailureCount((prevCount) => data.failureCount || prevCount);
            setStatus11(data.status); // Update the status for withdraw11
        } catch (error) {
            console.error("Error fetching another one failure count:", error);
        } finally {
            setIsLoading(false);
        }
    };
    const fetchAnother13FailureCount = async () => {
        setIsLoading(true);
        try {
            const data = await fetchAnother13FailureCountApi(); // Call the separated API function
            // setPreviousTagValidity(tagvalidity);
            // setTagValidity(data.tagvalidity || "0");
            if (tagvalidity != data.tagvalidity) {
                setPreviousTagValidity(tagvalidity);
                setTagValidity(data.tagvalidity); // Set tag validity
            }
            setFailureCount((prevCount) => data.failureCount || prevCount);
            setStatus13(data.status); // Update the status for withdraw13
        } catch (error) {
            console.error("Error fetching failure count for withdraw13:", error);
        } finally {
            setIsLoading(false);
        }
    };
    const fetchAnother10FailureCount = async () => {
        setIsLoading(true);
        try {
            const data = await fetchAnother10FailureCountApi(); // Call the separated API function
            // setPreviousTagValidity(tagvalidity);
            // setTagValidity(data.tagvalidity || "0");
            if (tagvalidity != data.tagvalidity) {
                setPreviousTagValidity(tagvalidity);
                setTagValidity(data.tagvalidity); // Set tag validity
            }
            setFailureCount((prevCount) => data.failureCount || prevCount);
            setStatus10(data.status); // Update the status for withdraw13
        } catch (error) {
            console.error("Error fetching failure count for withdraw13:", error);
        } finally {
            setIsLoading(false);
        }
    };
    const fetchAnother12FailureCount = async () => {
        setIsLoading(true);
        try {
            const data = await fetchAnother12FailureCountApi(); // Call the separated API function
            // setPreviousTagValidity(tagvalidity);
            // setTagValidity(data.tagvalidity || "0");
            if (tagvalidity != data.tagvalidity) {
                setPreviousTagValidity(tagvalidity);
                setTagValidity(data.tagvalidity); // Set tag validity
            }
            setFailureCount((prevCount) => data.failureCount || prevCount);
            setStatus12(data.status); // Update the status for withdraw13
        } catch (error) {
            console.error("Error fetching failure count for withdraw13:", error);
        } finally {
            setIsLoading(false);
        }
    };
    const fetchAnother14FailureCount = async () => {
        setIsLoading(true);
        try {
            const data = await fetchAnother14FailureCountApi(); // Call the API function
            // setPreviousTagValidity(tagvalidity);
            // setTagValidity(data.tagvalidity || "0");
            if (tagvalidity != data.tagvalidity) {
                setPreviousTagValidity(tagvalidity);
                setTagValidity(data.tagvalidity); // Set tag validity
            }
            setFailureCount((prevCount) => data.failureCount || prevCount);
            setStatus14(data.status); // Update the status for withdraw14
        } catch (error) {
            console.error("Error fetching failure count for withdraw14:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const formatNumberWithCommas = (value) => {
        // Remove all non-numeric characters (to handle user input correctly)
        value = value.replace(/[^0-9]/g, "");

        // First handle Indian number system for lakh, crore, etc.
        if (value.length > 3) {
            let lastThree = value.slice(-3); // Get the last three digits
            let otherNumbers = value.slice(0, value.length - 3); // Get the rest of the number

            // Format the first part using comma every two digits
            otherNumbers = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",");

            // Join the formatted parts
            return otherNumbers + "," + lastThree;
        }

        // If the number is less than 1000, just return the value (without commas)
        return value;
    };

    // Function to remove commas from a formatted number
    const removeCommas = (value) => {
        return value.replace(/,/g, "");
    };

    const handleAmountChange = (e) => {
        // Remove non-numeric characters and commas
        const numericValue = e.target.value.replace(/[^0-9]/g, "");
        // Check if the numeric value is 0
        if (numericValue === "0") {
            // Set an empty string or show a warning
            setAmount("");
            alert("The minimum transaction amount should be 1");
            return;
        }

        // Format the numeric value with commas
        const formattedValue = formatNumberWithCommas(numericValue);

        // Update the amount state
        setAmount(formattedValue);
    };
    const handleAmountChange5 = (e) => {
        // Remove non-numeric characters and commas
        const numericValue = e.target.value.replace(/[^0-9]/g, "");
        // Check if the numeric value is 0
        if (numericValue === "0") {
            // Set an empty string or show a warning
            setAmount1("");
            alert("The minimum transaction amount should be 1");
            return;
        }

        // Format the numeric value with commas
        const formattedValue = formatNumberWithCommas(numericValue);

        // Update the amount state
        setAmount1(formattedValue);
    };
    const handleAmountChange5to7 = (e) => {
        // Remove non-numeric characters and commas
        const numericValue = e.target.value.replace(/[^0-9]/g, "");
        // Check if the numeric value is 0
        if (numericValue === "0") {
            // Set an empty string or show a warning
            setAmount2("");
            alert("The minimum transaction amount should be 1");
            return;
        }

        // Format the numeric value with commas
        const formattedValue = formatNumberWithCommas(numericValue);

        // Update the amount state
        setAmount2(formattedValue);
    };
    const handleAmountChange5to8 = (e) => {
        // Remove non-numeric characters and commas
        const numericValue = e.target.value.replace(/[^0-9]/g, "");
        // Check if the numeric value is 0
        if (numericValue === "0") {
            // Set an empty string or show a warning
            setAmount3("");
            alert("The minimum transaction amount should be 1");
            return;
        }

        // Format the numeric value with commas
        const formattedValue = formatNumberWithCommas(numericValue);

        // Update the amount state
        setAmount3(formattedValue);
    };
    const handleAmountChange6to9 = (e) => {
        // Remove non-numeric characters and commas
        const numericValue = e.target.value.replace(/[^0-9]/g, "");
        // Check if the numeric value is 0
        if (numericValue === "0") {
            // Set an empty string or show a warning
            setAmount4("");
            alert("The minimum transaction amount should be 1");
            return;
        }

        // Format the numeric value with commas
        const formattedValue = formatNumberWithCommas(numericValue);

        // Update the amount state
        setAmount4(formattedValue);
    };
    const handleAmountChange6to10 = (e) => {
        // Remove non-numeric characters and commas
        const numericValue = e.target.value.replace(/[^0-9]/g, "");
        // Check if the numeric value is 0
        if (numericValue === "0") {
            // Set an empty string or show a warning
            setAmount5("");
            alert("The minimum transaction amount should be 1");
            return;
        }

        // Format the numeric value with commas
        const formattedValue = formatNumberWithCommas(numericValue);

        // Update the amount state
        setAmount5(formattedValue);
    };
    const handleAmountChange7to11 = (e) => {
        // Remove non-numeric characters and commas
        const numericValue = e.target.value.replace(/[^0-9]/g, "");
        // Check if the numeric value is 0
        if (numericValue === "0") {
            // Set an empty string or show a warning
            setAmount6("");
            alert("The minimum transaction amount should be 1");
            return;
        }

        // Format the numeric value with commas
        const formattedValue = formatNumberWithCommas(numericValue);

        // Update the amount state
        setAmount6(formattedValue);
    };
    const handleAmountChange7to12 = (e) => {
        // Remove non-numeric characters and commas
        const numericValue = e.target.value.replace(/[^0-9]/g, "");
        // Check if the numeric value is 0
        if (numericValue === "0") {
            // Set an empty string or show a warning
            setAmount7("");
            alert("The minimum transaction amount should be 1");
            return;
        }

        // Format the numeric value with commas
        const formattedValue = formatNumberWithCommas(numericValue);

        // Update the amount state
        setAmount7(formattedValue);
    };
    const handleAmountChange8to13 = (e) => {
        // Remove non-numeric characters and commas
        const numericValue = e.target.value.replace(/[^0-9]/g, "");
        // Check if the numeric value is 0
        if (numericValue === "0") {
            // Set an empty string or show a warning
            setAmount8("");
            alert("The minimum transaction amount should be 1");
            return;
        }

        // Format the numeric value with commas
        const formattedValue = formatNumberWithCommas(numericValue);

        // Update the amount state
        setAmount8(formattedValue);
    };
    const handleAmountChange8to14 = (e) => {
        // Remove non-numeric characters and commas
        const numericValue = e.target.value.replace(/[^0-9]/g, "");
        // Check if the numeric value is 0
        if (numericValue === "0") {
            // Set an empty string or show a warning
            setAmount9("");
            alert("The minimum transaction amount should be 1");
            return;
        }

        // Format the numeric value with commas
        const formattedValue = formatNumberWithCommas(numericValue);

        // Update the amount state
        setAmount9(formattedValue);
    };

    const handleTransfer = async () => {
        if (!amount) {
            alert("Please enter an amount.");
            return;
        }

        try {
            // Call the API function from the utils file
            const data = await handleTransferApi(amount);

            setTag4(data.tag4);
            setTag5(data.tag5); // Set tag5 from the API response

            setAmountTransferred5(data.amountTransferred5);
            setIsTransactionSuccessful(true); // Mark the transaction as successful
            // Store the old tag validity
            console.log(tagvalidity);
            if (tagvalidity != data.tagvalidity) {
                setPreviousTagValidity(tagvalidity);
                setTagValidity(data.tagvalidity); // Set tag validity
            }

            console.log(data);
        } catch (error) {
            console.error("Error during transfer:", error);
        }
    };
    const handleTransfer5to6 = async () => {
        if (!amount1) {
            alert("Please enter an amount.");
            return;
        }

        try {
            // Call the API function from the utils file
            const data = await handleTransferApi5to6(amount1);

            // Retain the old tag5 data and only set tag6 from the API response

            if (data.tag6 == "1B4B5") {
                setPanicMessage("Blocked");
            }

            setTag6(data.tag6); // Set tag6 from the API response
            setAmountTransferred6(data.amountTransferred6);
            setIsTransactionSuccessful5(true); // Mark the transaction as successful
            if (tagvalidity != data.tagvalidity) {
                setPreviousTagValidity(tagvalidity);
                setTagValidity(data.tagvalidity); // Set tag validity
            }
            console.log(data);
        } catch (error) {
            console.error("Error during transfer:", error);
        }
    };
    const handleTransfer5to7 = async () => {
        if (!amount2) {
            alert("Please enter an amount.");
            return;
        }

        try {
            // Call the API function from the utils file
            const data = await handleTransferApi5to7(amount2);

            if (data.tag7 == "1B4B5") {
                setPanicMessage("Blocked");
            }

            // Retain the old tag5 data and only set tag6 from the API response
            setTag7(data.tag7); // Set tag6 from the API response
            setAmountTransferred7(data.amountTransferred7);
            setIsTransactionSuccessful5to7(true); // Mark the transaction as successful
            if (tagvalidity != data.tagvalidity) {
                setPreviousTagValidity(tagvalidity);
                setTagValidity(data.tagvalidity); // Set tag validity
            }
            console.log(data);
        } catch (error) {
            console.error("Error during transfer:", error);
        }
    };
    const handleTransfer5to8 = async () => {
        if (!amount3) {
            alert("Please enter an amount.");
            return;
        }

        try {
            // Call the API function from the utils file
            const data = await handleTransferApi5to8(amount3);

            if (data.tag8 == "1B4B5") {
                setPanicMessage("Blocked");
            }

            // Retain the old tag5 data and only set tag6 from the API response
            setTag8(data.tag8); // Set tag6 from the API response
            setAmountTransferred8(data.amountTransferred8);
            setIsTransactionSuccessful5to8(true); // Mark the transaction as successful
            if (tagvalidity != data.tagvalidity) {
                setPreviousTagValidity(tagvalidity);
                setTagValidity(data.tagvalidity); // Set tag validity
            }
            console.log(data);
        } catch (error) {
            console.error("Error during transfer:", error);
        }
    };
    const handleTransfer6to9 = async () => {
        if (!amount4) {
            alert("Please enter an amount.");
            return;
        }

        try {
            // Call the API function from the utils file
            const data = await handleTransferApi6to9(amount4);

            if (data.tag9 == "1B4B5") {
                setPanicMessage("Blocked");
            }

            // Retain the old tag5 data and only set tag6 from the API response
            setTag9(data.tag9); // Set tag6 from the API response
            setAmountTransferred9(data.amountTransferred9);
            setIsTransactionSuccessful6to9(true); // Mark the transaction as successful
            if (tagvalidity != data.tagvalidity) {
                setPreviousTagValidity(tagvalidity);
                setTagValidity(data.tagvalidity); // Set tag validity
            }
            console.log(data);
        } catch (error) {
            console.error("Error during transfer:", error);
        }
    };
    const handleTransfer6to10 = async () => {
        if (!amount5) {
            alert("Please enter an amount.");
            return;
        }

        try {
            // Call the API function from the utils file
            const data = await handleTransferApi6to10(amount5);
            if (data.tag10 == "1B4B5") {
                setPanicMessage("Blocked");
            }

            // Retain the old tag5 data and only set tag6 from the API response
            setTag10(data.tag10); // Set tag6 from the API response
            setAmountTransferred10(data.amountTransferred10);
            setIsTransactionSuccessful6to10(true); // Mark the transaction as successful
            if (tagvalidity != data.tagvalidity) {
                setPreviousTagValidity(tagvalidity);
                setTagValidity(data.tagvalidity); // Set tag validity
            }
            console.log(data);
        } catch (error) {
            console.error("Error during transfer:", error);
        }
    };
    const handleTransfer7to11 = async () => {
        if (!amount6) {
            alert("Please enter an amount.");
            return;
        }

        try {
            // Call the API function from the utils file
            const data = await handleTransferApi7to11(amount6);
            if (data.tag11 == "1B4B5") {
                setPanicMessage("Blocked");
            }

            // Retain the old tag5 data and only set tag6 from the API response
            setTag11(data.tag11); // Set tag6 from the API response
            setAmountTransferred11(data.amountTransferred11);
            setIsTransactionSuccessful7to11(true); // Mark the transaction as successful
            if (tagvalidity != data.tagvalidity) {
                setPreviousTagValidity(tagvalidity);
                setTagValidity(data.tagvalidity); // Set tag validity
            }
            console.log(data);
        } catch (error) {
            console.error("Error during transfer:", error);
        }
    };
    const handleTransfer7to12 = async () => {
        if (!amount7) {
            alert("Please enter an amount.");
            return;
        }

        try {
            // Call the API function from the utils file
            const data = await handleTransferApi7to12(amount7);
            if (data.tag12 == "1B4B5") {
                setPanicMessage("Blocked");
            }

            // Retain the old tag5 data and only set tag6 from the API response
            setTag12(data.tag12); // Set tag6 from the API response
            setAmountTransferred12(data.amountTransferred12);
            setIsTransactionSuccessful7to12(true); // Mark the transaction as successful
            if (tagvalidity != data.tagvalidity) {
                setPreviousTagValidity(tagvalidity);
                setTagValidity(data.tagvalidity); // Set tag validity
            }
            console.log(data);
        } catch (error) {
            console.error("Error during transfer:", error);
        }
    };
    const handleTransfer8to13 = async () => {
        if (!amount8) {
            alert("Please enter an amount.");
            return;
        }

        try {
            // Call the API function from the utils file
            const data = await handleTransferApi8to13(amount8);
            if (data.tag13 == "1B4B5") {
                setPanicMessage("Blocked");
            }

            // Retain the old tag5 data and only set tag6 from the API response
            setTag13(data.tag13); // Set tag6 from the API response
            setAmountTransferred13(data.amountTransferred13);
            setIsTransactionSuccessful8to13(true); // Mark the transaction as successful
            if (tagvalidity != data.tagvalidity) {
                setPreviousTagValidity(tagvalidity);
                setTagValidity(data.tagvalidity); // Set tag validity
            }
            console.log(data);
        } catch (error) {
            console.error("Error during transfer:", error);
        }
    };
    const handleTransfer8to14 = async () => {
        if (!amount9) {
            alert("Please enter an amount.");
            return;
        }

        try {
            // Call the API function from the utils file
            const data = await handleTransferApi8to14(amount9);
            if (data.tag14 == "1B4B5") {
                setPanicMessage("Blocked");
            }

            // Retain the old tag5 data and only set tag6 from the API response
            setTag14(data.tag14); // Set tag6 from the API response
            setAmountTransferred14(data.amountTransferred14);
            setIsTransactionSuccessful8to14(true); // Mark the transaction as successful
            if (tagvalidity != data.tagvalidity) {
                setPreviousTagValidity(tagvalidity);
                setTagValidity(data.tagvalidity); // Set tag validity
            }
            console.log(data);
        } catch (error) {
            console.error("Error during transfer:", error);
        }
    };
    let updateAmountSatus = () => {
        console.log(
            tag5,
            tag6,
            tag7,
            tag8,
            tag9,
            tag10,
            tag11,
            tag12,
            tag13,
            tag14
        );

        const tags = {
            tag5,
            tag6,
            tag7,
            tag8,
            tag9,
            tag10,
            tag11,
            tag12,
            tag13,
            tag14,
        };

        const updatedStatus = {};

        for (const [key, value] of Object.entries(tags)) {
            if (value) {
                updatedStatus[key] = true;
            }
        }

        setAmountStatus((prev) => ({
            ...prev,
            ...updatedStatus,
        }));
    };

    const handlePanicButtonClick = async () => {
        // alert("hiiiiiiii");
        updateAmountSatus();
        setIsLoading(true);
        try {
            // Clear any previous panic message before the API call
            setPanicMessage(null);

            const part1Value = "1B4B5"; // Hardcoded value for "part1"

            const data = await markFraud(part1Value); // Use the API function

            if (data) {
                // Show the message if it's present
                if (
                    [
                        tag5,
                        tag6,
                        tag7,
                        tag8,
                        tag9,
                        tag10,
                        tag11,
                        tag12,
                        tag13,
                        tag14,
                    ].some((tag) => tag.split("-")[0] === part1Value)
                ) {
                    setPanicMessage(data.message);
                    updateAmountSatus();
                } else {
                    setPanicMessage(null);
                }
            } else {
                setPanicMessage(null); // Clear any previous panic message if there's an error
            }
        } catch (error) {
            console.error("Error occurred while calling API:", error);
            setPanicMessage(null); // Clear any previous panic message if an error occurs
        } finally {
            setIsLoading(false);
        }
    };

    const handleTruncate = async () => {
        setLoading(true); // Show loader
        try {
            const status = await handleTruncateApi();
            setStatus(status);
            setFailureCount(0); // Reset Withdrawal Attempts
            setPreviousTagValidity(null); // Clear Previous Tag Validity
            setTagValidity(0); // Reset Tag Validity to 0
            setTimeout(() => setStatus(null), 1000);
        } catch (error) {
            console.error("Error during truncate operation:", error);
        } finally {
            setLoading(false); // Hide loader
        }
    };

    // Function to call the insert-data API
    const handleInsert = async () => {
        setLoading1(true); // Show loader
        try {
            const status1 = await handleInsertApi();
            setStatus1(status1);
            setTimeout(() => setStatus1(null), 1000);
        } catch (error) {
            console.error("Error during insert operation:", error);
        } finally {
            setLoading1(false); // Hide loader
        }
    };

    const navigate = useNavigate(); // Initialize useNavigate hook

    const handleLogout = () => {
        // Clear login status from localStorage
        localStorage.removeItem("isLoggedIn");

        // Notify other tabs about logout
        localStorage.setItem("logout-event", Date.now());

        // Redirect to LoginPage (forces reload in all tabs)
        window.location.href = "/";
    };

    return (
        <>
            <h1 className="main-title">
                Fraud Modus Operandi 1
                <button className="logout-btn" onClick={handleLogout}>
                    Logout
                </button>
            </h1>
            <div className="bank-wrapper">
                {/* Horizontal Container for Bank 4 and Bank 5 */}



                <div className="horizontal-bank-container">
                    {/* Bank4 Container */}

                    <div className="bank-label41">Bank 4</div>
                    <div className="tag-label1">Tager code B4</div>


                    <div className="bank-container bank41-container">
                        {isTransactionSuccessful ? (
                            <div className="transaction-success-message4to5">
                                Transaction successful!
                                <img
                                    src={Panic} // Replace with the actual path to the panic button image
                                    onClick={handlePanicButtonClick}
                                    style={{
                                        cursor: "pointer",
                                        width: "75px", // Set desired width
                                        height: "auto", // Maintain aspect ratio
                                        position: "absolute", // To position it freely inside the success container
                                        top: "-10px", // Adjust placement from the top
                                        right: "-75px", // Adjust placement from the right
                                    }}
                                />
                            </div>
                        ) : (
                            <div className="amount-container">
                                <input
                                    type="text"
                                    className={`amount-input ${amount ? "prefilled" : ""}`}
                                    value={amount}
                                    onChange={handleAmountChange}
                                    style={{
                                        width: "95px",
                                        padding: "5px",
                                        fontSize: "14px",
                                        position: "relative",
                                        top: "15px",
                                        paddingLeft: "20px",
                                        left: "5px",
                                        fontWeight: "bold", // Make the text bold
                                    }}
                                />

                                <button className="transfer-button" onClick={handleTransfer}>
                                    Transfer
                                </button>
                            </div>
                        )}
                    </div>

                    <div className="floating-image-container">
                        <img
                            src={FederalImage}
                            alt="Federal Logo"
                            className="above-container-image"
                        />
                    </div>
                    {/* <div className="arrow">&#8594;</div> */}
                    {/* Arrow from Bank 4 to Bank 5 */}
                    <div className="arrow-to-bank5">&#8594;</div>
                    {/* <div className="arrow-containers">
        <div className="arrow-to-bank5"><img src={arrowImage} alt="Curved Arrow" className="arrow-images" /></div>
        </div> */}
                    <div className="floating-image-container2">
                        <img
                            src={cub}
                            alt="cub Logo"
                            className="above-container-image"
                        />
                    </div>
                    <div className="bank-container bank51-container">
                        <div className="bank-label5">Bank 5</div> {/* Bank label */}
                        <div className="tag-label2">Tager code B5</div>
                        {/*  Bank transfer 5 to 6 */}
                        {isTransactionSuccessful5 ? (
                            <div className="transaction-success-message5to61">
                                Transaction successful!
                            </div>
                        ) : (
                            <div className="amount-containernew">
                                <input
                                    type="text"
                                    className={`amount-input ${amount1 ? "prefilled" : ""}`}
                                    value={amount1}
                                    onChange={handleAmountChange5}
                                    style={{
                                        width: "95px",
                                        padding: "5px",
                                        fontSize: "14px",
                                        position: "relative",
                                        top: "15px",
                                        paddingLeft: "20px",
                                        left: "5px",
                                        fontWeight: "bold", // Make the text bold
                                    }}
                                />

                                <button
                                    className="transfer-button"
                                    onClick={() => {
                                        handleTransfer5to6(); // Your transfer logic
                                        setIsTransactionSuccessful5(true); // Set transaction success to true
                                    }}>
                                    Transfer
                                </button>
                            </div>
                        )}
                        {/*  Bank transfer 5 to 7 */}
                        {/* Dotted divider between 5 to 6 and 5 to 7 */}
                        <div className="dotted-divider5to6"></div>
                        {isTransactionSuccessful5to7 ? (
                            <div className="transaction-success-message5to7">
                                Transaction successful!
                            </div>
                        ) : (
                            <div className="amount-containernew">
                                <input
                                    type="text"
                                    className={`amount-input ${amount2 ? "prefilled" : ""}`}
                                    value={amount2}
                                    onChange={handleAmountChange5to7}
                                    style={{
                                        width: "95px",
                                        padding: "5px",
                                        fontSize: "14px",
                                        position: "relative",
                                        top: "15px",
                                        paddingLeft: "20px",
                                        left: "5px",
                                        fontWeight: "bold", // Make the text bold
                                    }}
                                />

                                <button
                                    className="transfer-button"
                                    onClick={() => {
                                        handleTransfer5to7(); // Your transfer logic
                                        setIsTransactionSuccessful5to7(true); // Set transaction success to true
                                    }}>
                                    Transfer
                                </button>
                            </div>
                        )}
                        {/*  Bank transfer 5 to 8 */}
                        <div className="dotted-divider5to6"></div>
                        {isTransactionSuccessful5to8 ? (
                            <div className="transaction-success-message15to18">
                                Transaction successful!
                            </div>
                        ) : (
                            <div className="amount-containernew">
                                <input
                                    type="text"
                                    className={`amount-input ${amount3 ? "prefilled" : ""}`}
                                    value={amount3}
                                    onChange={handleAmountChange5to8}
                                    style={{
                                        width: "95px",
                                        padding: "5px",
                                        fontSize: "14px",
                                        position: "relative",
                                        top: "15px",
                                        paddingLeft: "20px",
                                        left: "5px",
                                        fontWeight: "bold", // Make the text bold
                                    }}
                                />

                                <button
                                    className="transfer-button"
                                    onClick={() => {
                                        handleTransfer5to8(); // Your transfer logic
                                        setIsTransactionSuccessful5to8(true); // Set transaction success to true
                                    }}>
                                    Transfer
                                </button>
                            </div>
                        )}
                        <div className="icon-container">
                            <div className="icon">
                                <img src={atmImage} alt="ATM" className="icon-image" />
                                <button
                                    className="button123"
                                    onClick={() => fetchFailureCount("ATM")}>
                                    ATM
                                    {statusATM === "Failure" && (
                                        <span className="status-icon1">
                                            <img src={XMark} alt="POS" className="icon-image" />
                                        </span>
                                    )}
                                </button>
                            </div>
                            <div className="icon">
                                <img src={posImage} alt="POS" className="icon-image" />
                                <button
                                    className="button123"
                                    onClick={() => fetchFailureCount("POS")}>
                                    Pay
                                    {statusPOS === "Failure" && (
                                        <span className="status-icon2">
                                            <img src={XMark} alt="POS" className="icon-image" />
                                        </span>
                                    )}
                                </button>
                            </div>
                            <div className="icon">
                                <img
                                    src={shoppingImage}
                                    alt="Online Shopping"
                                    className="icon-image"
                                />
                                <button
                                    className="button123"
                                    onClick={() => fetchFailureCount("BUY")}>
                                    Buy
                                    {statusBuy === "Failure" && (
                                        <span className="status-icon3">
                                            <img src={XMark} alt="POS" className="icon-image" />
                                        </span>
                                    )}
                                </button>
                            </div>
                            <div className="icon">
                                <img
                                    src={QRImage}
                                    alt="Online Shopping"
                                    className="icon-image"
                                />
                                <button
                                    className="button1"
                                    onClick={() => fetchFailureCount("UPI MERCHANT")}>
                                    UPI Merchant
                                    {statusUpi === "Failure" && (
                                        <span className="status-icon4">
                                            <img src={XMark} alt="POS" className="icon-image" />
                                        </span>
                                    )}
                                </button>
                            </div>
                        </div>

                        <div className="tag-amount-container">
                            {tag5 && (
                                <div className="tag-response-wrapper">
                                    {tag5.split("-")[0] === "1B4B5" && (
                                        <div className="panic-message1">
                                            {/* {panicMessage} */}
                                            {/* <i className="fas fa-ban "></i> Disabled icon */}
                                        </div>
                                    )}

                                    {showAmountStatus.tag5 && (
                                        <>
                                            <div className="panic-message1new">
                                                Amount Blocked <i className="fas fa-ban "></i>{" "}
                                            </div>
                                        </>
                                    )}
                                    <div className="tag-response41c">P23-ywn-46fer-78912</div>
                                    {amountTransferred5 && (
                                        <div className="amount-transferred55b">
                                            ₹ {formatNumberWithCommas(amountTransferred5.toString())}
                                        </div>
                                    )}
                                </div>
                            )}

                            {tag6 && (
                                <div className="tag-response-wrapper">
                                    {tag6.split("-")[0] === "1B4B5" && (
                                        <div className="panic-message4new">
                                            {/* {panicMessage} */}
                                            {/* <i className="fas fa-ban "></i>{" "} */}
                                            {/* Disabled icon */}
                                        </div>
                                    )}
                                    {showAmountStatus.tag6 && (
                                        <>
                                            <div className="panic-message4new">
                                                Amount Blocked <i className="fas fa-ban "></i>{" "}
                                            </div>
                                        </>
                                    )}
                                    <div className="tag56-response">B954801-fgaqshivop</div>
                                    {amountTransferred6 && (
                                        <div className="amount-transferred56c">
                                            ₹ {formatNumberWithCommas(amountTransferred6.toString())}
                                        </div>
                                    )}
                                </div>
                            )}

                            {tag7 && (
                                <div className="tag-response-wrapper">
                                    {tag7.split("-")[0] === "1B4B5" && (
                                        <div className="panic-message37">
                                            {/* {panicMessage} */}
                                            {/* <i className="fas fa-ban "></i>{" "} */}
                                            {/* Disabled icon */}
                                        </div>
                                    )}
                                    {/* <div className="tag773-response">{tag7}</div> */}
                                    {showAmountStatus.tag7 && (
                                        <>
                                            <div className="panic-message37new">
                                                Amount Blocked <i className="fas fa-ban "></i>{" "}
                                            </div>
                                        </>
                                    )}
                                    <div className="tag773-response">J56-6fgb-abn-yu-3644</div>
                                    {amountTransferred7 && (
                                        <div className="amount-transferred773c">
                                            ₹ {formatNumberWithCommas(amountTransferred7.toString())}
                                        </div>
                                    )}
                                </div>
                            )}

                            {tag8 && (
                                <div className="tag-response-wrapper">
                                    {tag8.split("-")[0] === "1B4B5" && (
                                        <div className="panic-message222">
                                            {/* {panicMessage} */}
                                            {/* <i className="fas fa-ban "></i>{" "} */}
                                            {/* Disabled icon */}
                                        </div>
                                    )}
                                    {/* <div className="tag823-response">{tag8}</div> */}
                                    {showAmountStatus.tag8 && (
                                        <>
                                            <div className="panic-message222new">
                                                Amount Blocked <i className="fas fa-ban "></i>{" "}
                                            </div>
                                        </>
                                    )}
                                    <div className="tag823b-response">O635651-23rok-qasdf</div>
                                    {amountTransferred8 && (
                                        <div className="amount-transferred829c">
                                            ₹ {formatNumberWithCommas(amountTransferred8.toString())}
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                        <div className="tag-responses-container">
                            {/* Tag 9 */}
                            {tag9 && (
                                <div className="tag-response-wrapper">
                                    {tag9.split("-")[0] === "1B4B5" && (
                                        <div className="panic-message519">
                                            {/* {panicMessage} */}
                                            {/* <i className="fas fa-ban "></i>{" "} */}
                                            {/* Disabled icon */}
                                        </div>
                                    )}
                                    {/* <div className="tag911-response">{tag9}</div> */}
                                    {showAmountStatus.tag9 && (
                                        <>
                                            <div className="panic-message519new">
                                                Amount Blocked <i className="fas fa-ban "></i>{" "}
                                            </div>
                                        </>
                                    )}
                                    <div className="tag911-response">12937ghirmns</div>
                                    {amountTransferred9 && (
                                        <div className="amount-transferred911a">
                                            ₹ {formatNumberWithCommas(amountTransferred9.toString())}
                                        </div>
                                    )}
                                </div>
                            )}

                            {/* Tag 10 */}
                            {tag10 && (
                                <div className="tag-response-wrapper">
                                    {tag10.split("-")[0] === "1B4B5" && (
                                        <div className="panic-message610">
                                            {/* {panicMessage} */}
                                            {/* <i className="fas fa-ban "></i>{" "} */}
                                            {/* Disabled icon */}
                                        </div>
                                    )}
                                    {/* <div className="tag1000-response">{tag10}</div> */}
                                    {showAmountStatus.tag10 && (
                                        <>
                                            <div className="panic-message610new">
                                                Amount Blocked <i className="fas fa-ban "></i>{" "}
                                            </div>
                                        </>
                                    )}
                                    <div className="tag1000-response">Nde-sdfg-asenm-9038</div>
                                    {amountTransferred10 && (
                                        <div className="amount-transferred100a">
                                            ₹ {formatNumberWithCommas(amountTransferred10.toString())}
                                        </div>
                                    )}
                                </div>
                            )}

                            {/* Tag 11 */}
                            {tag11 && (
                                <div className="tag-response-wrapper">
                                    {tag11.split("-")[0] === "1B4B5" && (
                                        <div className="panic-message71">
                                            {/* {panicMessage} */}
                                            {/* <i className="fas fa-ban "></i>{" "} */}
                                            {/* Disabled icon */}
                                        </div>
                                    )}
                                    {/* <div className="tag1111-response">{tag11}</div> */}
                                    {showAmountStatus.tag11 && (
                                        <>
                                            <div className="panic-message71new">
                                                Amount Blocked <i className="fas fa-ban "></i>{" "}
                                            </div>
                                        </>
                                    )}
                                    <div className="tag1111-response">Kqwva-12nf4567</div>
                                    {amountTransferred11 && (
                                        <div className="amount-transferred111as">
                                            ₹ {formatNumberWithCommas(amountTransferred11.toString())}
                                        </div>
                                    )}
                                </div>
                            )}

                            {/* Tag 12 */}
                            {tag12 && (
                                <div className="tag-response-wrapper">
                                    {tag12.split("-")[0] === "1B4B5" && (
                                        <div className="panic-message81">
                                            {/* {panicMessage} */}
                                            {/* <i className="fas fa-ban "></i>{" "} */}
                                            {/* Disabled icon */}
                                        </div>
                                    )}
                                    {/* <div className="tag121-response">{tag12}</div> */}
                                    {showAmountStatus.tag12 && (
                                        <>
                                            <div className="panic-message81new">
                                                Amount Blocked <i className="fas fa-ban "></i>{" "}
                                            </div>
                                        </>
                                    )}
                                    <div className="tag121-response">7823-opieq-zxcvb431</div>
                                    {amountTransferred12 && (
                                        <div className="amount-transferred121b">
                                            ₹ {formatNumberWithCommas(amountTransferred12.toString())}
                                        </div>
                                    )}
                                </div>
                            )}
                            {/* Tag 12 */}
                            {tag13 && (
                                <div className="tag-response-wrapper">
                                    {tag13.split("-")[0] === "1B4B5" && (
                                        <div className="panic-message91">
                                            {/* {panicMessage} */}
                                            {/* <i className="fas fa-ban "></i>{" "} */}
                                            {/* Disabled icon */}
                                        </div>
                                    )}
                                    {/* <div className="tag131-response">{tag13}</div> */}
                                    {showAmountStatus.tag13 && (
                                        <>
                                            <div className="panic-message91new">
                                                Amount Blocked <i className="fas fa-ban "></i>{" "}
                                            </div>
                                        </>
                                    )}
                                    <div className="tag131-response">Qfwaih-9041378</div>
                                    {amountTransferred13 && (
                                        <div className="amount-transferred131b">
                                            ₹ {formatNumberWithCommas(amountTransferred13.toString())}
                                        </div>
                                    )}
                                </div>
                            )}
                            {tag14 && (
                                <div className="tag-response-wrapper">
                                    {tag14.split("-")[0] === "1B4B5" && (
                                        <div className="panic-message101">
                                            {/* {panicMessage} */}
                                            {/* <i className="fas fa-ban "></i>{" "} */}
                                            {/* Disabled icon */}
                                        </div>
                                    )}
                                    {/* <div className=" tag141-response">{tag14}</div> */}
                                    {showAmountStatus.tag14 && (
                                        <>
                                            <div className="panic-message101new">
                                                Amount Blocked{" "}
                                                <i className="fas fa-ban "></i>{" "}
                                            </div>
                                        </>
                                    )}
                                    <div className="tag141-response">901-yup-aqzmcvbdjk</div>
                                    {amountTransferred14 && (
                                        <div className="amount-transferred141">
                                            ₹ {formatNumberWithCommas(amountTransferred14.toString())}
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                    {/* Add the arrows */}
                    <div className="arrow-container">
                        <div className="arrow-to-bank6">&#8594;</div>
                        <div className="arrow-to-bank7">&#8594;</div>
                        <div className="arrow-to-bank8">&#8594;</div>
                    </div>
                </div>


                {/* Vertical Bank Containers */}
                <div className="vertical-bank-container">


                    <div className="vertical-bank-item">
                        <div className="bank-label6">NBFC 6</div>{" "}
                        {/* Added Bank label here */}
                        <div className="tag-label3">Tager code B6</div>
                        {/* Bank transfer 6 to 9 */}
                        {isTransactionSuccessful6to9 ? (
                            <div className="transaction-success-message6to9">
                                Transaction successful!
                            </div>
                        ) : (
                            <div className="amount-containernew">
                                <input
                                    type="text"
                                    className={`amount-input ${amount4 ? "prefilled" : ""}`}
                                    value={amount4}
                                    onChange={handleAmountChange6to9}
                                    style={{
                                        width: "95px",
                                        padding: "5px",
                                        fontSize: "14px",
                                        position: "relative",
                                        top: "15px",
                                        paddingLeft: "20px",
                                        left: "5px",
                                        fontWeight: "bold", // Make the text bold
                                    }}
                                />

                                <button
                                    className="transfer-button"
                                    onClick={() => {
                                        handleTransfer6to9(); // Your transfer logic
                                        setIsTransactionSuccessful6to9(true); // Set transaction success to true
                                    }}>
                                    Transfer
                                </button>
                            </div>
                        )}
                        {/* Bank transfer 6 to 10 */}
                        <div className="dotted-divider2"></div>
                        {isTransactionSuccessful6to10 ? (
                            <div className="transaction-success-message6to10">
                                Transaction successful!
                            </div>
                        ) : (
                            <div className="amount-container">
                                <input
                                    type="text"
                                    className={`amount-input ${amount5 ? "prefilled" : ""}`}
                                    value={amount5}
                                    onChange={handleAmountChange6to10}
                                    style={{
                                        width: "95px",
                                        padding: "5px",
                                        fontSize: "14px",
                                        position: "relative",
                                        top: "5px",
                                        paddingLeft: "20px",
                                        left: "5px",
                                        fontWeight: "bold", // Make the text bold
                                    }}
                                />

                                <button
                                    className="transfer-button6"
                                    onClick={() => {
                                        handleTransfer6to10(); // Your transfer logic
                                        setIsTransactionSuccessful6to10(true); // Set transaction success to true
                                    }}>
                                    Transfer
                                </button>
                            </div>
                        )}
                    </div>
                    <div className="floating-image-container3">
                        <img
                            src={sbi}
                            alt="sbi Logo"
                            className="above-container-image3"
                        />
                    </div>
                    <div className="floating-image-container4">
                        <img
                            src={citi}
                            alt="citi Logo"
                            className="above-container-image4"
                        />
                    </div>

                    {/* Bank transfer 7 to 11 */}
                    {/* <div className="icon-container7">
        <div className="iconinput" style={{
          width: "80px",
          padding: "5px",
          fontSize: "14px",
          position: "relative",
          top: "-2px",
          paddingLeft: "20px",
          left: "5px",
        }}>
          


      </div>
        <div className="icon7" onClick={fetchAnotherFailureCount}>
            <img src={atmImage} alt="ATM" className="icon-image" />
          </div>
          <div className="icon7" onClick={fetchAnotherFailureCount}>
            <img src={posImage} alt="POS" className="icon-image" />
          </div>
          <div className="icon7" onClick={fetchAnotherFailureCount}>
            <img src={shoppingImage} alt="Online Shopping" className="icon-image" />
          </div>
        </div> */}

                    <div className="vertical-bank-item">
                        <div className="bank-label7">Bank 7</div>{" "}
                        {/* Added Bank label here */}
                        {/* Bank 7 Container with Amount Input */}
                        <div className="tag-label4">Tager code B7</div>
                        {isTransactionSuccessful7to11 ? (
                            <div className="transaction-success-message7to11">
                                Transaction successful!
                            </div>
                        ) : (
                            <div className="amount-container">
                                <input
                                    type="text"
                                    className={`amount-input ${amount6 ? "prefilled" : ""}`}
                                    value={amount6}
                                    onChange={handleAmountChange7to11}
                                    style={{
                                        width: "95px",
                                        padding: "5px",
                                        fontSize: "14px",
                                        position: "relative",
                                        top: "15px",
                                        paddingLeft: "20px",
                                        left: "5px",
                                        fontWeight: "bold", // Make the text bold
                                    }}
                                />

                                <button
                                    className="transfer-button"
                                    onClick={() => {
                                        handleTransfer7to11(); // Your transfer logic
                                        setIsTransactionSuccessful7to11(true); // Set transaction success to true
                                    }}>
                                    Transfer
                                </button>
                            </div>
                        )}
                        <div className="dotted-divider2"></div>
                        {/* Bank transfer 7 to 12 */}
                        {isTransactionSuccessful7to12 ? (
                            <div className="transaction-success-message7to12">
                                Transaction successful!
                            </div>
                        ) : (
                            <div className="amount-container">
                                <input
                                    type="text"
                                    className={`amount-input ${amount7 ? "prefilled" : ""}`}
                                    value={amount7}
                                    onChange={handleAmountChange7to12}
                                    style={{
                                        width: "95px",
                                        padding: "5px",
                                        fontSize: "14px",
                                        position: "relative",
                                        top: "5px",
                                        paddingLeft: "20px",
                                        left: "5px",
                                        fontWeight: "bold", // Make the text bold
                                    }}
                                />
                                <button
                                    className="transfer-button7"
                                    onClick={() => {
                                        handleTransfer7to12(); // Your transfer logic
                                        setIsTransactionSuccessful7to12(true); // Mark transaction as successful
                                    }}>
                                    Transfer
                                </button>
                            </div>
                        )}
                    </div>


                    {/* Bank transfer 8 to 13 */}

                    <div className="vertical-bank-item">
                        <div className="bank-label8">Bank 8</div>{" "}
                        {/* Added Bank label here */}
                        <div className="tag-label5">Tager code B8</div>
                        {isTransactionSuccessful8to13 ? (
                            <div className="transaction-success-message8to13">
                                Transaction successful!
                            </div>
                        ) : (
                            <div className="amount-container">
                                <input
                                    type="text"
                                    className={`amount-input ${amount8 ? "prefilled" : ""}`}
                                    value={amount8}
                                    onChange={handleAmountChange8to13}
                                    style={{
                                        width: "95px",
                                        padding: "5px",
                                        fontSize: "14px",
                                        position: "relative",
                                        top: "15px",
                                        paddingLeft: "20px",
                                        left: "5px",
                                        fontWeight: "bold", // Make the text bold
                                    }}
                                />

                                <button
                                    className="transfer-button"
                                    onClick={() => {
                                        handleTransfer8to13(); // Your transfer logic
                                        setIsTransactionSuccessful8to13(true); // Set transaction success to true
                                    }}>
                                    Transfer
                                </button>
                            </div>
                        )}
                        {/* Bank transfer 8 to 14 */}
                        <div className="dotted-divider2"></div>
                        {/* Amount Container for Bank 8 to 14 */}
                        {isTransactionSuccessful8to14 ? (
                            <div className="transaction-success-message8to14">
                                Transaction successful!
                            </div>
                        ) : (
                            <div className="amount-container">
                                <input
                                    type="text"
                                    className={`amount-input ${amount9 ? "prefilled" : ""}`}
                                    value={amount9}
                                    onChange={handleAmountChange8to14}
                                    style={{
                                        width: "95px",
                                        padding: "5px",
                                        fontSize: "14px",
                                        position: "relative",
                                        top: "5px",
                                        paddingLeft: "20px",
                                        left: "5px",
                                        fontWeight: "bold", // Make the text bold
                                    }}
                                />

                                <button
                                    className="transfer-button8"
                                    onClick={() => {
                                        handleTransfer8to14(); // Your transfer logic
                                        setIsTransactionSuccessful8to14(true); // Set transaction success to true
                                    }}>
                                    Transfer
                                </button>
                            </div>
                        )}
                        <div className="button-container">
                            <button
                                className={`circle-button ${status === "success" ? "green" : "red"
                                    }`}
                                onClick={handleTruncate}
                                disabled={loading} // Disable button while loading
                            >
                                {loading ? (
                                    <span className="loader">...</span> // Show loader
                                ) : status === "success" ? (
                                    <FaCheckCircle />
                                ) : null}{" "}
                                {/* No text */}
                            </button>

                            <button
                                className={`circle-button2 ${status1 === "success" ? "green" : "red"
                                    }`}
                                onClick={handleInsert}
                                disabled={loading1} // Disable button while loading
                            >
                                {loading1 ? (
                                    <span className="loader">...</span> // Show loader
                                ) : status1 === "success" ? (
                                    <FaCheckCircle />
                                ) : null}{" "}
                                {/* No text */}
                            </button>

                            <img
                                src={map} // Replace with the actual path to your image
                                alt="Click to view India map"
                                onClick={handleOpen}
                                style={{
                                    cursor: "pointer",
                                    marginLeft: "10px",
                                    marginTop: "550px",
                                    width: "30px", // Set desired width
                                    height: "auto", // Maintain aspect ratio
                                }}
                            />
                            <Dialog
                                open={open}
                                onClose={handleCloses}
                                fullWidth
                                maxWidth="lg" // Adjust the size of the modal
                                PaperProps={{
                                    style: {
                                        margin: "0", // Remove any default margin
                                        maxWidth: "550px", // Set desired width
                                        marginLeft: "670px", // Align to the right of the page
                                        height: "100%", // Optional: full height for a sidebar effect
                                        height: "100vh", // Full height of the viewport
                                        width: "550px", // Fixed width
                                    },
                                }}>
                                <DialogTitle>
                                P23-ywn-46fer-78912
                                    <CloseIcon
                                        onClick={handleClose}
                                        style={{
                                            cursor: "pointer",
                                            position: "absolute",
                                            top: "10px",
                                            right: "10px",
                                        }}
                                    />
                                </DialogTitle>
                                <DialogContent
                                    style={{
                                        padding: "0",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        height: "100%",
                                    }}>
                                    <IndiaMap /> {/* Display the IndiaMap component here */}
                                </DialogContent>
                            </Dialog>

                            {/* Panic button */}
                            {/* <img
                src={Panic}
                onClick={handlePanicButtonClick}
                style={{
                  cursor: "pointer",
                  width: "75px", 
                  height: "auto", 
                  position: "absolute", 
                  bottom: "40px", 
                  right: "70px", 
                }}
              /> */}
                        </div>
                        <div className="floating-image-container5">
                            <img
                                src={rbl}
                                alt="rbl Logo"
                                className="above-container-image5"
                            />
                        </div>
                        <div className="floating-image-container6">
                            <img
                                src={indian2}
                                alt="indian Logo"
                                className="above-container-image6"
                            />
                        </div>
                        <div className="floating-image-container7">
                            <img
                                src={southindian}
                                alt="southindian Logo"
                                className="above-container-image7"
                            />
                        </div>
                        <div className="floating-image-container8">
                            <img
                                src={canara}
                                alt="canara Logo"
                                className="above-container-image8"
                            />
                        </div>

                        <div className="floating-image-container9">
                            <img
                                src={baroda}
                                alt="baroda Logo"
                                className="above-container-image9"
                            />
                        </div>
                        <div className="floating-image-container10">
                            <img
                                src={overseas}
                                alt="overseas Logo"
                                className="above-container-image10"
                            />
                        </div>
                        <div className="floating-image-container11">
                            <img
                                src={idbi}
                                alt="idbi Logo"
                                className="above-container-image11"
                            />
                        </div>
                        <div className="floating-image-container12">
                            <img
                                src={hdfc}
                                alt="hdfc Logo"
                                className="above-container-image12"
                            />
                        </div>
                        <div className="fund-movement-container">
                            <div className="fund-movement">
                                Fund Movement :{" "}
                                <span className="red-value">
                                    {count !== null ? count : "Loading..."}
                                </span>
                            </div>
                            <div className="time-taken">
                                Time Taken:{" "}
                                <span className="red-value">
                                    {timeDifference !== null
                                        ? `${timeDifference} `
                                        : "Loading..."}
                                </span>
                            </div>
                            <div className="withdrawal-count">
                                Withdrawal Attempts:{" "}
                                <span className="red-value">
                                    {failureCount !== null ? `${failureCount} ` : "0"}
                                </span>
                            </div>
                            <div className="tag-validity">
                                Tag Validity:
                                {tagvalidity === 0 ? (
                                    <span className="red-value">0</span>
                                ) : previousTagValidity &&
                                    previousTagValidity !== tagvalidity ? (
                                    <>
                                        <span
                                            style={{ textDecoration: "line-through" }}
                                            className="red-value">
                                            {previousTagValidity}{" "}
                                        </span>
                                        <span className="red-value">{tagvalidity}</span>
                                    </>
                                ) : (
                                    <span className="red-value">
                                        {tagvalidity !== null ? `${tagvalidity}` : "0"}
                                    </span>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                {/* <div className="icon-container8">
        <div className="iconinput8" style={{
          width: "80px",
          padding: "5px",
          fontSize: "14px",
          position: "relative",
          top: "-3px",
          paddingLeft: "20px",
          left: "5px",
        }}>
          


      </div>
        <div className="icon" onClick={fetchAnotheroneFailureCount}>
            <img src={atmImage} alt="ATM" className="icon-image" />
          </div>
          <div className="icon" onClick={fetchAnotheroneFailureCount}>
            <img src={posImage} alt="POS" className="icon-image" />
          </div>
          <div className="icon" onClick={fetchAnotheroneFailureCount}>
            <img src={shoppingImage} alt="Online Shopping" className="icon-image" />
          </div>
        </div> */}

                <div className="arrow-containernew">
                    <div className="arrow-to-bank9">&#8594;</div>
                    <div className="arrow-to-bank10">&#8594;</div>

                    <div className="arrow-to-bank11"> &#8594;</div>
                    <div className="arrow-to-bank12">&#8594;</div>

                    <div className="arrow-to-bank13">&#8594;</div>
                    <div className="arrow-to-bank14">&#8594;</div>
                </div>
                <div className="vertical-bank-container2">
                    <div className="vertical-bank-item3">
                        {/* Bank 9 Label */}
                        <div className="bank-label9">Bank 9</div>{" "}
                        {/* Added Bank 9 label here */}
                        <div className="tag-label6">Tager code B9</div>
                        <div className="icon-container9">
                            <div className="icon9">
                                <img
                                    src={shoppingImage}
                                    alt="Online Shopping"
                                    className="icon-image9"
                                />
                                <button className="button9" onClick={fetchAnotherFailureCount}>
                                    Online Purchase
                                    {status9 === "Failure" && (
                                        <span className="status-icon">
                                            <img src={XMark} alt="POS" className="icon-image" />
                                        </span>
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="vertical-bank-item3">
                        {/* Bank 10 Label */}
                        <div className="bank-label10">Bank 10</div>{" "}
                        {/* Added Bank 9 label here */}
                        <div className="tag-label7">Tager code B10</div>
                        <div className="icon-container10">
                            <div className="icon13">
                                <img src={QRImage} alt="POS" className="icon-image13" />
                                <button
                                    className="button1"
                                    onClick={fetchAnother10FailureCount}>
                                    UPI Merchant
                                    {status10 === "Failure" && (
                                        <span className="status-icon">
                                            <img src={XMark} alt="POS" className="icon-image" />
                                        </span>
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className="vertical-bank-item3">
                        {/* Bank 11 Label */}
                        <div className="bank-label11">Bank 11</div>{" "}
                        {/* Added Bank 9 label here */}
                        <div className="tag-label8">Tager code B11</div>
                        <div className="icon-container11">
                            <div className="icon11">
                                <img src={atmImage} alt="ATM" className="icon-image11" />
                                <button
                                    className="button1"
                                    onClick={fetchAnotheroneFailureCount}>
                                    ATM
                                    {status11 === "Failure" && (
                                        <span className="status-icon">
                                            <img src={XMark} alt="POS" className="icon-image" />
                                        </span>
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="vertical-bank-item3">
                        {/* Bank 11 Label */}
                        <div className="bank-label12">Bank 12</div>{" "}
                        {/* Added Bank 9 label here */}
                        <div className="tag-label9">Tager code B12</div>
                        <div className="icon-container13">
                            <div className="icon13">
                                <img src={crypto1} alt="POS" className="icon-image13" />
                                <button
                                    className="button1"
                                    onClick={fetchAnother12FailureCount}>
                                    Crypto Wallet
                                    {status12 === "Failure" && (
                                        <span className="status-icon">
                                            <img src={XMark} alt="POS" className="icon-image" />
                                        </span>
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="vertical-bank-item3">
                        {/* Bank 13 Label */}
                        <div className="bank-label13">Bank 13</div>
                        <div className="tag-label10">Tager code B13</div>

                        <div className="icon-container13">
                            <div className="icon13">
                                <img src={posImage} alt="POS" className="icon-image13" />
                                <button
                                    className="button1"
                                    onClick={fetchAnother13FailureCount}>
                                    {" "}
                                    Pos Pay
                                    {status13 === "Failure" && (
                                        <span className="status-icon">
                                            <img src={XMark} alt="POS" className="icon-image" />
                                        </span>
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className="vertical-bank-item3">
                        {/* Bank 14 Label */}
                        <div className="bank-label14">Bank 14</div>{" "}
                        {/* Added Bank 9 label here */}
                        <div className="tag-label11">Tager code B14</div>
                        <div className="icon-container14">
                            <div className="icon14">
                                <img src={International} alt="POS" className="icon-image14" />
                                <button
                                    className="button1"
                                    onClick={fetchAnother14FailureCount}>
                                    Intl Transfer
                                    {status14 === "Failure" && (
                                        <span className="status-icon">
                                            <img src={XMark} alt="POS" className="icon-image" />
                                        </span>
                                    )}
                                </button>
                            </div>
                            {/* <div className="merchant-text">Merchant</div> */}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default BankTransfer4to5new1;
